// DI   TGP-027
// Transform-based carousel with smooth drag and auto-snap animation

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.reviews-carousel');
  
  carousels.forEach((carousel) => {
    const reviewCount = parseInt(carousel.dataset.reviewCount, 10);
    
    if (reviewCount <= 1) return;
    
    const trackContainer = carousel.querySelector('.carousel-track-container');
    const track = carousel.querySelector('.carousel-track');
    const prevButton = carousel.querySelector('.carousel-nav--prev');
    const nextButton = carousel.querySelector('.carousel-nav--next');
    const cards = Array.from(carousel.querySelectorAll('.review-card'));
    
    if (!trackContainer || !track || !prevButton || !nextButton || cards.length === 0) return;
    
    let currentIndex = 0;
    let isDown = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragDistance = 0;
    
    function updateButtonStates() {
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex === cards.length - 1;
    }
    
    function setSlidePosition() {
      const slideWidth = trackContainer.offsetWidth;
      currentTranslate = -currentIndex * slideWidth;
      prevTranslate = currentTranslate;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
    
    function goToSlide(index) {
      if (index < 0 || index >= cards.length) return;
      currentIndex = index;
      setSlidePosition();
      updateButtonStates();
    }
    
    function startDrag(clientX) {
      isDown = true;
      startX = clientX;
      dragDistance = 0;
      track.classList.add('is-dragging');
    }
    
    function moveDrag(clientX) {
      if (!isDown) return;
      
      const currentX = clientX;
      dragDistance = currentX - startX;
      currentTranslate = prevTranslate + dragDistance;
      
      // Apply transform with drag
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
    
    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      
      // Threshold for switching slides (30% of container width)
      const threshold = trackContainer.offsetWidth * 0.3;
      
      // Determine direction and if threshold was met
      if (dragDistance < -threshold && currentIndex < cards.length - 1) {
        // Dragged left significantly, go to next
        currentIndex++;
      } else if (dragDistance > threshold && currentIndex > 0) {
        // Dragged right significantly, go to previous
        currentIndex--;
      }
      
      // Smoothly animate to the target slide
      setSlidePosition();
      updateButtonStates();
    }
    
    // Mouse events
    trackContainer.addEventListener('mousedown', (e) => {
      e.preventDefault();
      startDrag(e.clientX);
    });
    
    trackContainer.addEventListener('mousemove', (e) => {
      moveDrag(e.clientX);
    });
    
    trackContainer.addEventListener('mouseup', endDrag);
    trackContainer.addEventListener('mouseleave', () => {
      if (isDown) endDrag();
    });
    
    // Touch events for iOS and mobile
    trackContainer.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        startDrag(e.touches[0].clientX);
      }
    }, { passive: true });
    
    trackContainer.addEventListener('touchmove', (e) => {
      if (e.touches.length === 1) {
        moveDrag(e.touches[0].clientX);
      }
    }, { passive: true });
    
    trackContainer.addEventListener('touchend', endDrag, { passive: true });
    trackContainer.addEventListener('touchcancel', endDrag, { passive: true });
    
    // Button navigation
    prevButton.addEventListener('click', () => {
      goToSlide(currentIndex - 1);
    });
    
    nextButton.addEventListener('click', () => {
      goToSlide(currentIndex + 1);
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      setSlidePosition();
    });
    
    // Initialize
    setSlidePosition();
    updateButtonStates();
  });
});
